<template>
  <div>
  <div class="calendar">
    <div class="container">
      <div class="c-header">
        <ol>
          <li><el-date-picker @change="changeYear" v-model="year" type="year" placeholder="选择年" :clearable="false" > </el-date-picker></li>
          <li><i class="el-icon-arrow-left" @click="prevDate"></i><el-select @change="changeMonth" v-model="month" placeholder="请选择"><el-option v-for="item in monthOptions" :key="item" :label="item" :value="item"></el-option></el-select><i class="el-icon-arrow-right" @click="nextDate"></i></li>
          <li><el-select @change="changeHoliday" :disabled="disabled" v-model="holiday" placeholder="假期安排"><el-option v-for="item in holidayOptions" :key="item" :label="item" :value="item"></el-option></el-select></li>
        </ol>
        <div class="button" @click="onBack">返回今天</div>
      </div>
      <div class="c-body">
        <el-calendar v-model="dataTime">
          <!-- 这里使用的是 2.5 slot 语法，对于新项目请使用 2.6 slot 语法-->
          <template slot="dateCell" slot-scope="{ date, data }">
            <div slot="reference" class="div-Calendar" @click="handleMonthChanged(data.day)">
              <span class="canlendar-n" :class="getWeek(data.day) === '六' || getWeek(data.day) === '日' ? 'mo' : ''">{{data.day.split('-')[2]}}</span>
              <span class="canlendar-g" v-if="!getFestival(data.day) && !getLunarFestival(data.day)">{{getGregorianCalendar(data.day)}}</span>
              <span class="xiu" v-if="getNationalHolidays(data.day)"><i>{{ getNationalHolidays(data.day) }}</i></span>
              <span class="ban" v-if="getWorkDay(data.day)"><i>{{ getWorkDay(data.day) }}</i></span>
              <span class="canlendar-jq red" v-if="getFestival(data.day) && !getLunarFestival(data.day)">{{getFestival(data.day)}}</span>
              <span class="canlendar-jq" v-if="getJieqi24(data.day) === getLunarFestival(data.day)">{{getLunarFestival(data.day)}}</span>
              <span class="canlendar-g red" v-else>{{getLunarFestival(data.day)}}</span>
            </div>
          </template>
        </el-calendar>
      </div>
      <div class="festival-baike">
        <p><template v-if="festivalBaike.length > 0"><i>节日/纪念日</i><div><span v-for="(item, index) in festivalBaike" :key="index"><em :class="item.desc !== '' ? 'hover' : ''" @click="clickDrawer(item)">{{item.name}}</em></span></div></template><template v-else-if="getFestival()"><i>节日/纪念日</i><div><span><em @click="clickDrawer()" class="hover">{{getFestival()}}</em></span></div></template></p><p style="float:right">第{{getIndexInYearText()}}周 <em @click="astroDrawer(getXingZuoText())">[{{getXingZuoText()}}]</em></p>
      </div>
      <div class="c-trips">
          <span class="c-trips-span">{{getLunarFestivalText()}}<br>{{getYearInGanZhiText()}}</span>
          <ul>
            <li><i><router-link to="/yi">宜</router-link></i><span><em v-for="(item, index) in dayYiText" :key="index" @click="clickId(item.id)" :class="item.id == 0 ? 'revert' : ''">{{item.name}}</em></span></li>
            <li><i><router-link to="/ji">忌</router-link></i><span><em v-for="(item, index) in dayJiText" :key="index" @click="clickId2(item.id)" :class="item.id == 0 ? 'revert' : ''">{{item.name}}</em></span></li>
          </ul>
        </div>
        <div class="festival-baike3">
          今日花语：<span v-html="getFlowerLanguage()"></span>
        </div>
        <div class="festival-baike2">
          <p>上一节气：{{almanac.p}}</p><p>下一节气：{{almanac.n}}</p>
      </div>
    </div>
    <div class="info">
      <div class="info-btn">
        <el-radio-group v-model="infoBtn">
          <el-radio-button label="老黄历">老黄历</el-radio-button>
          <el-radio-button label="时辰分析">时辰分析</el-radio-button>
          <el-radio-button label="生辰八字">生辰八字</el-radio-button>
        </el-radio-group>
        <div class="language" v-if="languageVisible">
          <el-select v-model="languageValue" placeholder="请选择" @change="changeLanguage">
          <el-option
            v-for="item in languagePptions"
            :key="item"
            :label="item"
            :value="item">
          </el-option>
          </el-select>
        </div>
        <div v-show="infoBtn === '时辰分析'">
          <div class="button2" @click="onEchart" v-show="state === 0">图表分析</div>
          <div class="button2" @click="onTable" v-show="state === 1">文本分析</div>
        </div>
        <div v-show="infoBtn === '生辰八字'">
          <el-time-picker v-model="defaultTime" value-format="HH:mm:ss" :editable="false" placeholder="选择默认时间" @change="changeTime" ></el-time-picker>
        </div>
      </div>
      <ul v-show="infoBtn === '老黄历'">
        <li><label>佛历：</label><span>{{almanac.foto}}</span><router-link to="/fo">详情</router-link></li>
        <li><label>道历：</label><span>{{almanac.tao}}</span><router-link to="/dao">详情</router-link></li>
        <li><label>年：</label><span>{{almanac.a}}</span></li>
        <li><label>月名：</label><span>{{almanac.m}}</span></li>
        <li><label>月：</label><span>{{almanac.a1}}</span></li>
        <li><label>月相：</label><span>{{almanac.yuexiang}}</span></li>
        <li><label>日：</label><span>{{almanac.a2}}</span></li>
        <li><label>日禄：</label><span>{{almanac.rilu}}</span></li>
        <li><label>儒略日：</label><span>{{almanac.a3}}</span></li>
        <li><label>物候：</label><span>{{almanac.wuhou}}</span></li>
        <li><label>六曜：</label><span>{{almanac.liuyao}}</span></li>
        <li :class="almanac.d.length > 20 ? 'wd100' : ''"><label>彭祖百忌：</label><span>{{almanac.d}}</span></li>
        <li :class="almanac.js.length > 20 ? 'wd100' : ''"><label>吉神宜趋：</label><span>{{almanac.js}}</span></li>
        <li :class="almanac.xs.length > 20 ? 'wd100' : ''"><label>凶煞宜忌：</label><span>{{almanac.xs}}</span></li>
        <li><label>相冲：</label><span>{{almanac.e}}</span></li>
        <li><label>岁煞：</label><span>{{almanac.f}}</span></li>
        <li><label>星宿：</label><span>{{almanac.g}}</span></li>
        <li class="wd100"><label>星宿歌诀：</label><span>{{almanac.g1}}</span></li>
        <li><label>贵神方位：</label><span>{{almanac.h}}</span></li>
        <li><label>喜神方位：</label><span>{{almanac.i}}</span></li>
        <li><label>福神方位：</label><span>{{almanac.i1}}</span></li>
        <li><label>财神方位：</label><span>{{almanac.i2}}</span></li>
        <li><label>本月胎神：</label><span>{{almanac.i3}}</span></li>
        <li><label>今日胎神：</label><span>{{almanac.i4}}</span></li>
        <li><label>太岁方位：</label><span>{{almanac.i5}}</span></li>
        <li><label>值星：</label><span>{{almanac.j}}</span></li>
        <li><label>十二天神：</label><span>{{almanac.k}}</span></li>
        <li><label>空亡所值：</label><span>{{almanac.xun}}</span></li>
        <li class="wd100"><label>九星：</label><span>{{almanac.jiuxing}}</span></li>
        <li class="wd100"><label>九星歌诀：</label><span>{{almanac.jiuxingsong}}</span></li>
      </ul>
      <div class="almanac-table" v-show="infoBtn === '时辰分析' && state === 0" v-html="tableData"> </div>
      <div class="body" v-show="infoBtn === '时辰分析' && state === 1" >
        <div class="circle-container">  
          <div class="circle" v-html="echartHtml"></div> 
          <div class="trips">温馨提示：子时 = 丙子 + 戊子</div> 
        </div> 
      </div>
      <div v-show="infoBtn === '生辰八字'">
        <div class="almanac-table" v-html="tableData2"></div>
        <ul class="table-li">
         <li><label>胎元：</label><span>{{taiYuan}}（{{taiYuan2}}）</span></li>
         <li><label>胎息：</label><span>{{taiXi}}（{{taiXi2}}）</span></li>
         <li><label>命宫：</label><span>{{mingGong}}（{{mingGong2}}）</span></li>
         <li><label>身宫：</label><span>{{shenGong}}（{{shenGong2}}）</span></li>
         <li><label>日空：</label><span>{{dayXunKong}}</span></li>
         <li><label @click="clickName">更多>>&nbsp;&nbsp;</label><span>&nbsp;</span></li>
        </ul>
        <div class="trips5" @click="creatName">{{quewx}}{{changeName}}</div>
        <div class="namedata" v-show="nameDataVisible">
          <dl>
            <dt><span>名字</span></dt>
            <dd class="wx">五行</dd>
            <dd>简介</dd>
          </dl>
          <dl v-for="(item, index) in createNameData" :key="index">
            <dt><span>{{item.name}}</span></dt>
            <dd class="wx">{{item.wx}}</dd>
            <dd :title="item.desc">{{item.desc}}</dd>
          </dl>
        </div>
      </div>
    </div>
    </div>
    <footerCon></footerCon>
    <!--注释-->
    <el-drawer
      :title="drawerTitle"
      :visible.sync="drawerVisible"
      class="drawer-detail"
      direction="rtl"
      size= "50%"
      :before-close="handleClose">
      <div v-html="drawerHtml"></div>
    </el-drawer>
    <!--星座-->
    <el-drawer
      :title="drawerTitle2"
      :visible.sync="drawerVisible2"
      class="drawer-detail"
      direction="rtl"
      size= "50%"
      :before-close="handleClose2">
      <section class="astro">
        <div class="astro-table" v-html="astroTable"></div>
        <ul>
          <li v-for="(item, index) in astroBtn" :key="index" @click="astroDrawer2(item.value, index)" :class="{ on: activeIndex === index }"><span>{{item.name}}</span></li>
        </ul>
        <div class="astro-body" v-html="astroBody"></div>
      </section>
    </el-drawer>
  </div>
</template>
<script>
import footerCon from "@/components/footer";
import calendar from '@/utils/calendar';
import {Solar, SolarWeek, Lunar, HolidayUtil, I18n} from 'lunar-typescript';
import nameData from "@/utils/nameData";
import flower from "@/utils/flowerLanguage";
import astro from "@/utils/astro";
import c from '@/utils/c'
import yiji from '@/utils/yiji'
export default {
  components: {
    footerCon
  },
  data() {
    return {
      today: new Date().getFullYear() + '-' + (new Date().getMonth() + 1) + '-' + new Date().getDate(),
      year: new Date().getFullYear().toString(),
      month: new Date().getMonth() + 1 + '月',
      day:'',
      queryate: this.$route.query.date,
      defaultTime:null,
      monthOptions:['1月','2月','3月','4月','5月','6月','7月','8月','9月','10月','11月','12月'],
      holiday: '',
      holidayOptions:['元旦节','春节','清明节','劳动节','端午节','中秋节','国庆节'],
      languagePptions:['中文','English'],
      languageValue: '中文',
      languageVisible:false,
      disabled: false,
      dataTime: new Date(),
      festivalBaike:[],
      infoBtn:'老黄历',
      almanac:{
        c:'',
        b:'',
        foto:'',
        tao:'',
        a:'',
        a1:'',
        a2:'',
        a3:'',
        m:'',
        wuhou:'',
        syjy:'',
        zhishui:'',
        fenbing:'',
        gengtian:'',
        dejin:'',
        rilu:'',
        liuyao:'',
        d:'',
        yj1:'',
        yj2:'',
        js:'',
        xs:'',
        e:'',
        f:'',
        g:'',
        g1:'',
        h:'',
        i:'',
        i1:'',
        i2:'',
        i3:'',
        i4:'',
        i5:'',
        j:'',
        k:'',
        xun:'',
        jiuxing:'',
        jiuxingsong:'',
        p:'',
        n:'',
        x:'',
        shuJiu:'',
        fu:''
      },
      tableData:'',
      tableData2:'',
      taiYuan:'',
      taiYuan2:'',
      taiXi:'',
      taiXi2:'',
      mingGong:'',
      mingGong2:'',
      shenGong:'',
      shenGong2:'',
      dayXunKong:'',
      wuxing:'',
      quewx:'',
      main:{
        a:'',
        a1:'',
        a2:'',
        b:'',
        c:'',
        s1:'',
        s2:'',
        s3:'',
        s4:''
      },
      nameDataArr:nameData.data,
      createNameData:[],
      nameDataVisible:false,
      changeName:'点击获取名字',
      c:c.data,
      drawerVisible:false,
      drawerTitle:'',
      drawerHtml:'',
      flowerLanguage: flower.data,
      astro:astro.data,
      drawerTitle2:'',
      drawerVisible2:false,
      astroTable:'',
      astroBody:'',
      astroBtn:[
        { name:'配对', value:'' },
        { name:'个性', value:'character' },
        { name:'优缺点', value:'proscons' },
        { name:'爱情', value:'love' },
        { name:'男生', value:'boy' },
        { name:'女生', value:'girl' }
      ],
      activeIndex:0,
      state:0,
      echartHtml:'',
      dayYiText:[],
      dayJiText:[]
    };
  },
  mounted(){
    this.initTime()
    this.initData()
  },
  methods: {
    //默认数据
    initData(){
      if(this.queryate && this.isValidDateFormat(this.queryate)){
        this.dataTime = this.queryate
      }else{
        this.day =  new Date().getDate()
        this.dataTime = this.year + '-' + this.month.split('月')[0] + '-' + this.day
      }
      this.today = this.dataTime
      localStorage.setItem('c-queryate',this.today)
      this.methodAll()
    },
    isValidDateFormat(dateString) {
      // 正则表达式用于匹配YYYY-MM-DD格式
      const regex = /^\d{4}-\d{2}-\d{2}$/;
      
      // 验证格式并尝试转换为Date对象
      return regex.test(dateString) && !isNaN(new Date(dateString).valueOf());
    },
    //方法合集
    methodAll(){
      this.setLanguage()
      this.getLunarFestivalText()
      this.getYearInGanZhiText()
      this.getDayYiText();
      this.getDayJiText()
      this.getAlmanacData()
      this.getTableData()
      this.getTableData2()
      this.nameDataVisible = false
      this.changeName = '点击获取名字' 
      const now = new Date()
      let year = now.getFullYear()
      if(year < Number(this.year)){
        this.disabled = true
      }else{
        this.disabled = false
      }
    },
    //设置中英文
    setLanguage(){
      I18n.setLanguage(this.languageValue === '中文' ? 'chs' : 'en');
    },
    //中英文切换
    changeLanguage(val){
      this.languageValue = val
      // console.log('this.languageValue',this.languageValue)
      this.initData()
    },
    //选择年份
    changeYear(e){
      this.year = new Date(e).getFullYear().toString()
      this.holiday = ''
      this.dataTime = new Date(e).getFullYear() + '-' + (new Date().getMonth() + 1) + '-' + new Date().getDate()
      this.today = this.dataTime
      this.methodAll()
    },
    //选择月份
    changeMonth(){
      this.holiday = ''
      this.initData()
    },
    //选择假期
    changeHoliday(e){
      const date = HolidayUtil.getHolidays(this.year).filter(item => item._name === e && item._work === false)
      this.year = date[0]._day.split('-')[0].toString();
      this.month = date[0]._day.split('-')[1] + '月'
      this.dataTime = this.year + '-' + this.month.split('月')[0] + '-' + date[0]._day.split('-')[2]
      this.today = this.dataTime
      this.methodAll()
    },
    //上一个月
    prevDate(){
      if(this.month === '1月'){
        this.year = (Number(this.year) - 1).toString()
        this.month = '12月'
      }else{
        this.month = Number(this.month.split('月')[0]) - 1 + '月'
      }
      this.holiday = ''
      this.initData()
    },
    //下一个月
    nextDate(){
      if(this.month === '12月'){
        this.year = (Number(this.year) + 1).toString()
        this.month = '1月'
      }else{
        this.month = Number(this.month.split('月')[0]) + 1 + '月'
      }
      this.holiday = ''
      this.initData()
    },
    //返回今天
    onBack(){
      this.year = new Date().getFullYear().toString()
      this.month = new Date().getMonth() + 1  + '月'
      this.initData()
      this.holiday = ''
      if(this.queryate){
        window.location.href = this.$route.path
      }
    },
    //获取公历
    getGregorianCalendar(dateList){
      const d = Lunar.fromDate(new Date(dateList));
      return d.getDayInChinese()
    },
    //获取星期
    getWeek(dateList){
      var d = Lunar.fromDate(new Date(dateList));
      return d.getWeekInChinese()
    },
    //假期放假
    getNationalHolidays(dateList){
      const holidays = []
      HolidayUtil.getHolidays(this.year).forEach(item =>{
        if(item._work === false){
          holidays.push(item._day)
        }
      })
      for (var i = 0; i < holidays.length; i++) {
        if (dateList == holidays[i]) {
          return '休'
        }
      }
    },
    //假期调休
    getWorkDay(dateList){
      const holidays = []
      HolidayUtil.getHolidays(this.year).forEach(item =>{
        if(item._work === true){
          holidays.push(item._day)
        }
      })
      for (var i = 0; i < holidays.length; i++) {
        if (dateList == holidays[i]) {
          return '班'
        }
      }
    },
    //24节气
    getJieqi24(dateList){
      var solar = Solar.fromDate(new Date(dateList));
      // 转阴历
      var lunar = solar.getLunar();
      // 获取节气
      var d = Lunar.fromYmd(lunar._year,lunar._month,lunar._day);
      return d.getJieQi()
    },
    //获取公历节日
    getFestival(dateList) {
      const dateList2 = typeof dateList === 'undefined' ? this.today : dateList
      const solar = dateList2.split('-')
      const festival = calendar.festival.filter(item => item.date === Number(solar[1]) + '-' + Number(solar[2]))
      let festivalObj = ''
      if(festival.length > 0){
        festivalObj = festival[0].title
      }
      return festivalObj
    },
    //获取农历节日
    getLunarFestival(dateList) {
      let d = Solar.fromDate(new Date(dateList));
      const now = Solar.fromDate(new Date(dateList))
      const lunar = d.getLunar()
      const day = new Date()
      day.day = d.getDay()
      let text = ""
      if (1 === lunar.getDay()) {
        text = lunar.getMonthInChinese() + '月'
      }
      let otherFestivals = d.getOtherFestivals()
      if (otherFestivals.length > 0) {
        text = otherFestivals[0]
      }
      otherFestivals = lunar.getOtherFestivals()
      if (otherFestivals.length > 0) {
        text = otherFestivals[0]
      }
      let festivals = d.getFestivals()
      if (festivals.length > 0) {
        text = festivals[0]
      }
      festivals = lunar.getFestivals()
      if (festivals.length > 0) {
        text = festivals[0]
      }
      const jq = lunar.getJieQi()
      if (jq) {
        text = jq
      }
      day.text = text
      return text
    },
    //获取阳历时间
    getLunarFestivalText(){
      const d = Lunar.fromDate(new Date(this.today));
      return d.getMonthInChinese() + '月' + d.getDayInChinese()
    },
     //获取天干
    getYearInGanZhiText(){
      const d = Lunar.fromDate(new Date(this.today));
      return d.getYearInGanZhi() + ' ' + d.getYearShengXiao()
    },
    //获取每日宜
    getDayYiText(){
      const d = Lunar.fromDate(new Date(this.today));
      let l = d.getDayYi();
      let arr = []
      for (let i=0, j=l.length; i<j; i++){
        arr.push(l[i])
      }
      this.dayYiText =[]
      arr.forEach(item=>{
        this.dayYiText.push({
          id:0,
          name: item
        })
      })
      for(let i=0; i<this.dayYiText.length; i++){
        for(let j=0; j<yiji.data.length; j++){
          if(this.dayYiText[i].name == yiji.data[j].name){
            this.dayYiText[i].id = yiji.data[j].id
          }
        }
      }
    },
    //获取每日忌
    getDayJiText(){
      const d = Lunar.fromDate(new Date(this.today));
      let l = d.getDayJi();
      let arr = []
      for (let i=0, j=l.length; i<j; i++){
        arr.push(l[i])
      }
      this.dayJiText = []
      arr.forEach(item=>{
        this.dayJiText.push({
          id:0,
          name: item
        })
      })
      for(let i=0; i<this.dayJiText.length; i++){
        for(let j=0; j<yiji.data.length; j++){
          if(this.dayJiText[i].name == yiji.data[j].name){
            this.dayJiText[i].id = yiji.data[j].id
          }
        }
      }
    },
    clickId(id){
      if(id == 0){
        return
      }
      this.$router.push({
        path: '/yi/' + id
      });
    },
    clickId2(id){
      if(id == 0){
        return
      }
      this.$router.push({
        path: '/ji/' + id
      });
    },
    clickName(){
      this.$router.push({
        path: '/name'
      });
    },
    //获取星期
    getIndexInYearText(){
      var d = SolarWeek.fromDate(new Date(this.today), 1);
      return d.getIndexInYear();
    },
    //获取星座
    getXingZuoText(){
      var d = Solar.fromDate(new Date(this.today));
      return d.getXingZuo()
    },
    //今日花语
    getFlowerLanguage(){
      const date = this.today
      if(date !== ''){
        let _c = date.split('-')[1] + '-' + date.split('-')[2]
        let _d = this.flowerLanguage.filter(item => item.date === _c)
        if(_d.length > 0){
          return '<i>' + _d[0].name + '</i>（代表：' + _d[0].desc + '）'
        }else{
          return ''
        }
      }else{
        return ''
      }
    },
    //点击事件
    handleMonthChanged(dateList){
      this.holiday = ''
      this.year = dateList.split('-')[0]
      this.month = Number(dateList.split('-')[1]) + '月'
      this.day = Number(dateList.split('-')[2])
      this.today = this.year + '-' + this.month.split('月')[0] + '-' + this.day
      localStorage.setItem('c-queryate',this.today)
      this.methodAll()
    },
    //点击节日事件
    clickDrawer(item){
      // console.log(item)
      if(item){
        // this.drawerTitle = this.getJieqi24(this.today) === item.name ? item.name + '相关诗词' : item.name
        this.drawerHtml = item. desc
        if(this.drawerHtml !== ''){
          this.drawerVisible = true
        }
      }else{
        const arr = this.c.filter(item => item.name === this.getFestival())
        if(arr.length > 0){
          // this.drawerTitle = arr[0].name
          this.drawerHtml = arr[0].desc
          this.drawerVisible = true
        }
      }
    },
    handleClose(){
      this.drawerVisible = false
    },
    //星座
    astroDrawer(val){
      // console.log('val',val)
      // this.activeIndex = 0
      const content = this.astro.filter(item => item.name === val)
      if(content.length > 0){
        this.$router.push({
          path: '/xingzuo/' + content[0].en.toLowerCase()
        });
        // this.drawerTitle2 = content[0].name + '座(' + content[0].date + ')'
        // this.astroTable = content[0].table
        // this.astroBody = content[0].desc + content[0].peidui
        // this.drawerVisible2 = true
      }
    },
    astroDrawer2(val, index){
      const content = this.astro.filter(item => item.name === this.drawerTitle2.split('座')[0])[0]
      if(val === ''){
        this.astroBody = content.desc + content.peidui
      }else{
        this.astroBody = content[val]
      }
      this.activeIndex = index
    },
    handleClose2(){
      this.drawerVisible2 = false
    },
    //星座基本信息

    //基本信息
    getAlmanacData(){
      const s = Solar.fromDate(new Date(this.today))
      // console.log('s',s)
      const h = HolidayUtil.getHoliday(s.getYear(),s.getMonth(),s.getDay());
      const d = s.getLunar();
      const p = d.getPrevJieQi();
      const n = d.getNextJieQi();
      const foto = d.getFoto();
      const tao = d.getTao();
      const jiuxing = d.getDayNineStar();
      this.almanac.foto = foto.getYearInChinese() + '年 ' + foto.getMonthInChinese() + '月 ' + foto.getDayInChinese()
      this.almanac.tao = tao.getYearInChinese() + '年 ' + tao.getMonthInChinese() + '月 ' + tao.getDayInChinese()
      this.almanac.yuexiang = d.getYueXiang()
      this.almanac.a = d.getYearInGanZhi() + '年 属' + d.getYearShengXiao() + ' ' + d.getYearNaYin()
      this.almanac.a1 = d.getMonthInGanZhi() + '月 属' + d.getMonthShengXiao() + ' ' + d.getMonthNaYin()
      this.almanac.a2 = d.getDayInGanZhi() + '日 属' + d.getDayShengXiao() + ' ' + d.getDayNaYin()
      this.almanac.a3 = s.getJulianDay()
      this.almanac.b = d.getYearInChinese() + '年 ' + d.getMonthInChinese() + '月 ' + d.getDayInChinese() + ' (阴历)'
      this.almanac.c = s.getYear() + '年 ' + s.getMonth() + '月 ' + s.getDay() + '日 星期' + s.getWeekInChinese() + ' ' + s.getXingZuo() + '座 (阳历)'
      this.almanac.m = d.getSeason()
      this.almanac.d = d.getPengZuGan() + ' ' + d.getPengZuZhi()
      this.almanac.yj1 = d.getDayYi().join(' ')
      this.almanac.yj2 = d.getDayJi().join(' ')
      this.almanac.e = d.getDayShengXiao() + '日 冲' + d.getChongDesc()
      this.almanac.js = d.getDayJiShen().join(' ')
      this.almanac.xs = d.getDayXiongSha().join(' ')
      this.almanac.f = d.getSha()
      this.almanac.g = d.getGong() + '方' + d.getXiu() + d.getZheng() + d.getAnimal() + ' (' + d.getXiuLuck() + ')'
      this.almanac.g1 = d.getXiuSong()
      this.almanac.h = '阳贵神：' + d.getPositionYangGuiDesc() + ' 阴贵神：' + d.getPositionYinGuiDesc()
      this.almanac.i = d.getPositionXiDesc()
      this.almanac.i1 = d.getPositionFuDesc()
      this.almanac.i2 = d.getPositionCaiDesc()
      this.almanac.i3 = d.getMonthPositionTai()
      this.almanac.i4 = d.getDayPositionTai()
      this.almanac.i5 = d.getDayPositionTaiSuiDesc()
      let fs = [];
      let f = d.getFestivals();
      if (f) {
          for (let i = 0, j = f.length; i < j; i++) {
              fs.push(f[i]);
          }
      }
      f = d.getOtherFestivals();
      if (f) {
          for (let i = 0, j = f.length; i < j; i++) {
              fs.push(f[i]);
          }
      }
      f = s.getFestivals();
      if (f) {
          for (let i = 0, j = f.length; i < j; i++) {
              fs.push(f[i]);
          }
      }
      f = s.getOtherFestivals();
      if (f) {
          for (let i = 0, j = f.length; i < j; i++) {
              fs.push(f[i]);
          }
      }
      f = foto.getFestivals();
      if (f) {
          for (let i = 0, j = f.length; i < j; i++) {
              fs.push(f[i]);
          }
      }
      f = tao.getFestivals();
      if (f) {
          for (let i = 0, j = f.length; i < j; i++) {
              fs.push(f[i]);
          }
      }
      if (h) {
          fs.push(h.getName() + (h.isWork() ? '调休' : '放假'));
      }
      if(foto.getMonthInChinese() + '月' + foto.getDayInChinese() === '正月十四'){
        this.festivalBaike = []
      }else{
        this.festivalBaike = []
        let fs2 = []
        fs.forEach(item=>{
          if(typeof item._name != 'undefined'){
            fs2.push(item._name)
          }else{
            fs2.push(item)
          }
        })
        let fs3 = fs2.concat(this.getFestival())
        let getJieqi24 = this.getJieqi24(this.today).split(',')
        if(getJieqi24.length > 0){
          fs3 = getJieqi24.concat(fs3)
        }
        fs3 = this.unique(fs3)
        for(let i=0; i<fs3.length; i++){
          for(let j=0; j<this.c.length; j++){
            if(fs3[i] === this.c[j].name && this.c[j].isHide === true){
              this.festivalBaike.push(this.c[j])
            }
          }
        }
      }
      this.almanac.j = d.getZhiXing()
      this.almanac.k = d.getDayTianShen() + '(' + d.getDayTianShenType() + ') ' + d.getDayTianShenLuck()
      this.almanac.p = p.getName() + ' ' + p.getSolar().toYmdHms() + ' 星期' + p.getSolar().getWeekInChinese()
      this.almanac.n = n.getName() + ' ' + n.getSolar().toYmdHms() + ' 星期' + n.getSolar().getWeekInChinese()
      this.almanac.jiuxing = jiuxing.getNumber() + jiuxing.getColor() + ' - ' + jiuxing.getNameInTaiYi() + '星(' + jiuxing.getWuXing() + ') - ' + jiuxing.getTypeInTaiYi()
      this.almanac.jiuxingsong = jiuxing.getSongInTaiYi()
      this.almanac.xun = '年：' + d.getYearXunKong() + '      月：' + d.getMonthXunKong() + '      日：' + d.getDayXunKong()
      var shuJiu = d.getShuJiu();
      this.almanac.shuJiu = shuJiu ? shuJiu.toFullString() : ''
      var fu = d.getFu();
      this.almanac.fu = fu ? fu.toFullString() : ''
      // 物候
      this.almanac.wuhou = d.getHou() + '，' + d.getWuHou()
      // 六曜
      this.almanac.liuyao = d.getLiuYao()
      // 日禄
      this.almanac.rilu = d.getDayLu()
    },
    //数组去重
    unique(arr) {
      var newArr = [];
      for (var i = 0; i < arr.length; i++) {
        if (newArr.indexOf(arr[i]) == -1) {
          newArr.push(arr[i])
        }
      }
      return newArr;
    },
    //时辰分析
    getTableData(){
      const s = Solar.fromDate(new Date(this.today))
      const d = s.getLunar();
      const l = d.getTimes();
      this.echartHtml = ''
      this.tableData = '<table><tbody>';
      this.tableData += '<tr><td width="60">时辰</td>';
      for (let i = 0, j = l.length; i < j; i++) {
          this.tableData += '<td width="7%">' + l[i].getGanZhi() + '</td>';
      }
      this.tableData += '</tr>';

      this.tableData += '<tr><td>时刻</td>';
      for (let i = 0, j = l.length; i < j; i++) {
          this.tableData += '<td width="7%">' + l[i].getMinHm() + '-' + l[i].getMaxHm() + '</td>';
      }
      this.tableData += '</tr>';

      this.tableData += '<tr><td>天神</td>';
      for (let i = 0, j = l.length; i < j; i++) {
          this.tableData += '<td>' + l[i].getTianShen() + '</td>';
      }
      this.tableData += '</tr>';

      this.tableData += '<tr><td>黑黄道</td>';
      for (let i = 0, j = l.length; i < j; i++) {
          this.tableData += '<td>' + l[i].getTianShenType() + '</td>';
      }
      this.tableData += '</tr>';

      this.tableData += '<tr><td>吉凶</td>';
      let flag = 0
      if(l[0].getTianShenLuck() === l[12].getTianShenLuck()){
        flag = 0
      }else{
        flag = 1
      }
      for (let i = 0, j = l.length; i < j; i++) {
          this.tableData += '<td>' + l[i].getTianShenLuck() + '</td>';
          if(flag === 0){
            if( l[i].getTianShenLuck() === '凶'){
              this.echartHtml += '<div class="sector"><span class="blue">' + l[i].getTianShenLuck() + '</span></div> '
            }else if( l[i].getTianShenLuck() === '吉'){
              this.echartHtml += '<div class="sector"><span class="red">' + l[i].getTianShenLuck() + '</span></div> '
            }
          }else{
            if( l[i].getTianShenLuck() === '凶'){
              if(i === 0){
                this.echartHtml += '<div class="sector sector1"><span class="blue">' + l[i].getTianShenLuck() + '</span></div> '
              }else if(i === 12){
                this.echartHtml += '<div class="sector sector12"><span class="blue">' + l[i].getTianShenLuck() + '</span></div> '
              }else{
                this.echartHtml += '<div class="sector"><span class="blue">' + l[i].getTianShenLuck() + '</span></div> '
              }
            }else if( l[i].getTianShenLuck() === '吉'){
              if(i === 0){
                this.echartHtml += '<div class="sector sector1"><span class="red">' + l[i].getTianShenLuck() + '</span></div> '
              }else if(i === 12){
                this.echartHtml += '<div class="sector sector12"><span class="red">' + l[i].getTianShenLuck() + '</span></div> '
              }else{
                this.echartHtml += '<div class="sector"><span class="red">' + l[i].getTianShenLuck() + '</span></div> '
              }
            }
          }
      }
      this.tableData += '</tr>';

      this.tableData += '<tr><td>冲</td>';
      for (let i = 0, j = l.length; i < j; i++) {
          this.tableData += '<td>' + l[i].getChongDesc() + '</td>';
      }
      this.tableData += '</tr>';

      this.tableData += '<tr><td>煞</td>';
      for (let i = 0, j = l.length; i < j; i++) {
          this.tableData += '<td>' + l[i].getSha() + '</td>';
      }
      this.tableData += '</tr>';

      this.tableData += '<tr><td>宜</td>';
      for (let i = 0, j = l.length; i < j; i++) {
          this.tableData += '<td>' + l[i].getYi().join(' ') + '</td>';
      }
      this.tableData += '</tr>';

      this.tableData += '<tr><td>忌</td>';
      for (let i = 0, j = l.length; i < j; i++) {
          this.tableData += '<td>' + l[i].getJi().join(' ') + '</td>';
      }
      this.tableData += '</tr>';

      this.tableData += '</tbody></table>';
    },
    onEchart(){
      this.state = 1
    },
    onTable(){
      this.state = 0
    },
    //生辰八字
    getTableData2(){
      let year = Number( this.today.split('-')[0])
      let month =  Number(this.today.split('-')[1])
      let day =  Number(this.today.split('-')[2])
      let hour = Number(this.defaultTime.split(':')[0])
      let minute = Number(this.defaultTime.split(':')[1])
      let dateTime = year + '-' + month + '-' + day + ' ' + hour + ':' + minute + ':0'
      // console.log('dateTime',dateTime)
      this.year = year.toString();
      // this.year = this.year.substring(2,4)
      this.month = month + '月';
      this.day = day;
      // let dateTime = year + '-' + month + '-' + day + ' ' + hour + ':' + minute + ':0'
      const solar = Solar.fromYmdHms(year,month,day,hour,minute,0);
      const lunar = solar.getLunar();
      const bazi = lunar.getEightChar();
      this.tableData2 = '<table><tbody>';
      this.tableData2 += '<tr>';
      this.tableData2 += '<td>公历</td>';
      this.tableData2 += '<td>'+solar.getYear()+'年</td>';
      this.tableData2 += '<td>'+solar.getMonth()+'月</td>';
      this.tableData2 += '<td>'+solar.getDay()+'日</td>';
      this.tableData2 += '<td>'+lunar.getTimeZhi()+'时</td>';
      this.tableData2 += '</tr>';
      this.tableData2 += '<tr>';
      this.tableData2 += '<td>天干</td>';
      this.tableData2 += '<td>'+bazi.getYearShiShenGan()+'</td>';
      this.tableData2 += '<td>'+bazi.getMonthShiShenGan()+'</td>';
      this.tableData2 += '<td>'+bazi.getDayShiShenGan()+'</td>';
      this.tableData2 += '<td>'+bazi.getTimeShiShenGan()+'</td>';
      this.tableData2 += '</tr>';
      this.tableData2 += '<tr>';
      this.tableData2 += '<td>八字</td>';
      this.tableData2 += '<td>'+bazi.getYear()+'</td>';
      this.tableData2 += '<td>'+bazi.getMonth()+'</td>';
      this.tableData2 += '<td>'+bazi.getDay()+'</td>';
      this.tableData2 += '<td>'+bazi.getTime()+'</td>';
      this.tableData2 += '</tr>';
      this.tableData2 += '<tr>';
      this.tableData2 += '<td>地支</td>';
      this.tableData2 += '<td>'+bazi.getYearShiShenZhi()[0]+'</td>';
      this.tableData2 += '<td>'+bazi.getMonthShiShenZhi()[0]+'</td>';
      this.tableData2 += '<td>'+bazi.getDayShiShenZhi()[0]+'</td>';
      this.tableData2 += '<td>'+bazi.getTimeShiShenZhi()[0]+'</td>';
      this.tableData2 += '</tr>';
      this.tableData2 += '<tr>';
      this.tableData2 += '<td>五行</td>';
      this.tableData2 += '<td>'+bazi.getYearWuXing()+'</td>';
      this.tableData2 += '<td>'+bazi.getMonthWuXing()+'</td>';
      this.tableData2 += '<td>'+bazi.getDayWuXing()+'</td>';
      this.tableData2 += '<td>'+bazi.getTimeWuXing()+'</td>';
      this.tableData2 += '</tr>';
      this.tableData2 += '<tr>';
      this.tableData2 += '<td>纳音</td>';
      this.tableData2 += '<td>'+bazi.getYearNaYin()+'</td>';
      this.tableData2 += '<td>'+bazi.getMonthNaYin()+'</td>';
      this.tableData2 += '<td>'+bazi.getDayNaYin()+'</td>';
      this.tableData2 += '<td>'+bazi.getTimeNaYin()+'</td>';
      this.tableData2 += '</tr>';
      this.tableData2 += '<tr>';
      this.tableData2 += '<td>地势</td>';
      this.tableData2 += '<td>'+bazi.getYearDiShi()+'</td>';
      this.tableData2 += '<td>'+bazi.getMonthDiShi()+'</td>';
      this.tableData2 += '<td>'+bazi.getDayDiShi()+'</td>';
      this.tableData2 += '<td>'+bazi.getTimeDiShi()+'</td>';
      this.tableData2 += '</tr>';
      this.tableData2 += '</tbody></table>'
      this.wuxing = bazi.getYearWuXing() + bazi.getMonthWuXing() + bazi.getDayWuXing() + bazi.getTimeWuXing()
      this.taiYuan =  bazi.getTaiYuan()
      this.taiYuan2 = bazi.getTaiYuanNaYin()
      this.taiXi = bazi.getTaiXi()
      this.taiXi2 = bazi.getTaiXiNaYin()
      this.mingGong = bazi.getMingGong()
      this.mingGong2 = bazi.getMingGongNaYin()
      this.shenGong = bazi.getShenGong()
      this.shenGong2 = bazi.getShenGongNaYin()
      this.dayXunKong = bazi.getDayXunKong()
      const s = Solar.fromDate(this.formatterDate(dateTime));
      // const h = HolidayUtil.getHoliday(s.getYear(),s.getMonth(),s.getDay());
      const d = s.getLunar();
      this.main.a = d.getYearInGanZhi() + '年 属' + d.getYearShengXiao() + ' ' + d.getYearNaYin()
      this.main.a1 = d.getMonthInGanZhi() + '月 属' + d.getMonthShengXiao() + ' ' + d.getMonthNaYin()
      this.main.a2 = d.getDayInGanZhi() + '日 属' + d.getDayShengXiao() + ' ' + d.getDayNaYin()
      this.main.a3 = s.getJulianDay()
      this.main.b = d.getYearInChinese() + '年 ' + d.getMonthInChinese() + '月 ' + d.getDayInChinese() + ' (阴历)'
      this.main.c = s.getYear() + '年 ' + s.getMonth() + '月 ' + s.getDay() + '日 星期' + s.getWeekInChinese() + ' ' + s.getXingZuo() + '座 (阳历)'
      this.main.s1 = d.getTimeGan()
      if(this.main.s1 === '戊' || this.main.s1 === '己'){
        this.main.s2 = '土'
      }else if(this.main.s1 === '庚' || this.main.s1 === '辛'){
        this.main.s2 = '金'
      }else if(this.main.s1 === '壬' || this.main.s1 === '癸'){
        this.main.s2 = '水'
      }else if(this.main.s1 === '甲' || this.main.s1 === '乙'){
        this.main.s2 = '木'
      }else if(this.main.s1 === '丙' || this.main.s1 === '丁'){
        this.main.s2 = '火'
      }
      this.main.s3 = d.getTimeZhi()
      if(this.main.s3 === '丑' || this.main.s3 === '戌' || this.main.s3 === '未' || this.main.s3 === '辰'){
        this.main.s4 = '土'
      }else if(this.main.s3 === '申' || this.main.s3 === '酉'){
        this.main.s4 = '金'
      }else if(this.main.s3 === '子' || this.main.s3 === '亥'){
        this.main.s4 = '水'
      }else if(this.main.s3 === '寅' || this.main.s3 === '卯'){
        this.main.s4 = '木'
      }else if(this.main.s3 === '巳' || this.main.s3 === '午'){
        this.main.s4 = '火'
      }
      let quewx = ''
      if(this.wuxing.indexOf('金') === -1){
        quewx += '金'
      }
      if(this.wuxing.indexOf('木') === -1){
        quewx += '木'
      }
      if(this.wuxing.indexOf('水') === -1){
        quewx += '水'
      }
      if(this.wuxing.indexOf('火') === -1){
        quewx += '火'
      }
      if(this.wuxing.indexOf('土') === -1){
        quewx += '土'
      }
      this.quewx = quewx === '' ? '' : '当前时辰五行缺' + quewx + '，'
    },
    formatterDate (date) {
      let result = new Date(date);
      return result;
    },
    initTime(){
      let date = new Date()
      this.defaultTime = this.formatTime(date.getHours(), date.getMinutes(), date.getSeconds());
    },
    formatTime(hours, minutes, seconds) {
      return `${this.padStart(hours)}:${this.padStart(minutes)}:${this.padStart(seconds)}`;
    },
    padStart(value) {
      return value.toString().padStart(2, '0');
    },
    changeTime(val){
      this.defaultTime = val
      this.nameDataVisible = false
      this.changeName = '点击获取名字' 
      this.getTableData2()
    },
    creatName(){
      let quewx = this.quewx !== '' ? this.quewx.replace('当前时辰五行缺', '').replace(/[`:_.~!@#$%^&*() \+ =<>?"{}|, \/ ;' \\ [ \] ·~！@#￥%……&*（）—— \+ ={}|《》？：“”【】、；‘’，。、]/g,'') : ''
      let quewxA = quewx.split('')
      let nameData = []
      if(quewxA.length === 0){
        nameData = this.nameDataArr
      }else if(quewxA.length === 1){
        const nameData1 = this.nameDataArr.filter(item =>item.wx1.indexOf(quewxA[0]) !== -1)
        const nameData2 = this.nameDataArr.filter(item =>item.wx2.indexOf(quewxA[0]) !== -1)
        nameData = nameData1.concat(nameData2)
      }else if(quewxA.length >= 2){
        const nameData1 = this.nameDataArr.filter(item =>item.wx1.indexOf(quewxA[0]) !== -1 && item.wx2.indexOf(quewxA[1]) !== -1)
        const nameData2 = this.nameDataArr.filter(item =>item.wx2.indexOf(quewxA[0]) !== -1 && item.wx1.indexOf(quewxA[1]) !== -1)
        nameData = nameData1.concat(nameData2)
      }
      let nameData2 = []
      nameData.forEach(item =>{
        if(item.type === 2){
          nameData2.push(item)
        }
      })
      const totalItems = nameData2.length;  
      const randomIndices = [];  
      while (randomIndices.length < 5) {  
        const randomIndex = Math.floor(Math.random() * totalItems);  
        if (!randomIndices.includes(randomIndex)) {  
          randomIndices.push(randomIndex);  
        }  
      }
      this.createNameData = []
      const createNameData = randomIndices.map(index => nameData2[index]); 
      createNameData.forEach(item => {
        const name = item.name.split('')
        this.createNameData.push({
          ...item,
          wx:name[0] + '字属' + item.wx1 + '，' + name[1] + '字属' + item.wx2,
          desc: item.typename !== ''  ? '出自《' + item.typename + '》：' + item.desc : item.desc
        })
      })
      this.nameDataVisible = true 
      this.changeName = '换一批名字'  
    }
  }
};
</script>
<style lang="scss" scoped>
@font-face {
  font-family: "JingHuaLaoSongTi";
  font-weight: normal;
  src: url("../assets/aliyun/8m2D40dU62JY.woff2") format("woff2"),
  url("../assets/aliyun/8m2D40dU62JY.woff") format("woff");
  font-display: swap;
  font-style: normal;
}
.calendar * {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.calendar {
  display: flex;
  justify-content: space-between;
  .container {
    width: 650px;
    box-shadow: 0 2px 8px 0 rgba(0,0,0,.08);
    border-radius: 15px;
    margin: 0;
    box-sizing: border-box;
    // border: 2px solid #4E6EF2;
    overflow: hidden;
    .c-header {
      position: relative;
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 55px;
      padding: 12px;
      background: #eaecf2;
      overflow: hidden;
      ol{
        display: flex;
        align-items: center;
        li{
          display: flex;
          align-items: center;
          position: relative;
          margin-right: 10px;
          width: 130px;
          i{
            color: #888;
            font-size: 16px;
            cursor: pointer;
            margin: 0 3px;
            &:hover{
              color: #333;
            }
          }
        }
      }
      .button{
        width: 72px;
        height: 32px;
        line-height: 32px;
        text-align: center;
        background: #fff;
        border-radius: 6px;
        color: #333;
        cursor: pointer;
        font-size: 13px;
        &:hover{
          color: #0f9fff;
          opacity: .75;
        }
      }
    }
    .c-body{
      width: 100%;
      overflow: hidden;
      .div-Calendar{
        position: relative;
        span{
          display: block;
          &.canlendar-n{
            margin-top: 8px;
            font-family: 'JingHuaLaoSongTi'; 
          }
          &.mo{
            color: #da5036;
          }
          &.canlendar-g{
            display: block;
            padding: 0 5px;
            font-size: 13px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
          &.canlendar-jq{
            display: block;
            padding: 0 5px;
            font-size: 13px;
            color: #23b255;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
          &.red{
            color: #da5036;
          }
          &.xiu{
            position: absolute;
            top: -8px;
            right: 0;
            font-size: 12px;
            &::before{
              display: block;
              content: '';
              width: 0;
              height: 0;
              border-top: 24px solid red;
              border-left: 24px solid transparent; 
            }
            i{
              position: absolute;
              right: 1px;
              top: 1px;
              z-index: 5;
              font-style: normal;
              color: #fff;
              font-size: 10px;
            }
          }
           &.ban{
            position: absolute;
            top: -8px;
            right: 0;
            font-size: 12px;
            &::before{
              display: block;
              content: '';
              width: 0;
              height: 0;
              border-top: 24px solid #888;
              border-left: 24px solid transparent; 
            }
            i{
              position: absolute;
              right: 1px;
              top: 1px;
              z-index: 5;
              color: #fff;
              font-size: 10px;
            }
          }
        }
      }
    }
  }
  .festival-baike{
      display: flex;
      background: rgba(245, 246, 249, .5);
      border-radius: 0.12rem;
      padding: 12px;
      border-bottom: 1px solid #EBEEF5;
      color: #36f;
      min-height: 48px;
      overflow: hidden;
      i{
        border: 1px solid #36f;
        padding: 1px 5px 0;
        border-radius: 2px;
        font-size: 13px;
        flex: 0 0 auto;
        height: 23px;
      }
      div{
        flex: 1 1 auto;
      }
      span{
        margin-left: 12px;
        display: inline-block;
        // cursor: pointer;
        // &:hover{
        //   text-decoration: underline;
        // }
      }
      p:nth-child(1){
        display: flex;
        width: 100%;
      }
      p:nth-child(2){
        width: 100px;
        text-align: right;
        em{
          color: #eb5b8d;
          cursor: pointer;
          &:hover{
            text-decoration: underline;
          }
        }
      }
      em{
        &.hover{
          cursor: pointer;
          &:hover{
            text-decoration: underline;
          }
        }
      }
  }
  .c-trips{
    display: flex;
    align-items: center;
    width: 650px;
    border-radius: 0 0 15px 15px;
    margin: 0;
    box-sizing: border-box;
    // border: 2px solid #4E6EF2;
    border-top: none;
    padding: 18px 10px;
    overflow: hidden;
    span.c-trips-span{
      font-family: 'JingHuaLaoSongTi'; 
      font-size: 28px;
      display: block;
      flex: 0 0 auto;
      width: 130px;
      line-height: 30px;
    }
    ul{
      flex: 1 1 auto;
      li{
        display: flex;
        // flex-wrap: wrap;
        font-size: 12px;
        margin: 5px;
        i a{
          display: block;
          padding: 0 2px;
          border-radius: 3px;
          margin-right: 8px;
          height: 20px;
          // line-height: 18px;
        }
        &:nth-child(1) i a{
          border: 1px solid #36f;
          color: #36f;
        }
        &:nth-child(2) i a{
          border: 1px solid #eb3333;
          color: #eb3333;
        }
        em{
          font-size: 14px;
          margin-right: 8px;
          cursor: pointer;
          &:hover{
            color: #36f;
            text-decoration: underline;
          }
        }
      }
    }
  }
  .festival-baike2{
    display: flex;
    justify-content: space-between;
    border-radius: 0.12rem;
    padding: 12px;
    color: #666;
  }
  .festival-baike3{
      display: flex;
      background: rgba(255, 120, 120, .1);
      border-radius: 0.12rem;
      padding: 12px;
      color: #eb3333;
      min-height: 24px;
      overflow: hidden;
      i{
        padding: 1px 5px 0;
        border-radius: 2px;
        font-size: 13px;
        flex: 0 0 auto;
        height: 24px;
      }
  }
  .info{
    width: calc(100% - 670px);
    margin: 0 0 0 20px;
    overflow: hidden;
    .info-btn{
      display: flex;
      margin-bottom: 15px;
    }
    .language{
      position: absolute;
      right: 20px;
      width: 110px;
    }
    h3{
      position: relative;
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 55px;
      padding: 12px 15px;
      background: #eaecf2;
      overflow: hidden;
      font-size: 18px;
      i{
        font-size: 16px;
        font-weight: normal;
        cursor: pointer;
        color: #36f;
        &:hover{
          opacity: .75;
        }
      }
    }
    ul{
      padding-bottom: 5px;
      box-shadow: 0 2px 8px 0 rgba(0,0,0,.08);
      border-radius: 15px;
      box-sizing: border-box;
      border: 1px solid #EBEEF5;
      min-height: 680px;
      overflow: hidden;
      li{
        display: flex;
        width: 50%;
        float: left;
        border-left: 1px solid #EBEEF5;
        border-top: 1px solid #EBEEF5;
        padding: 5px 8px 6px;
        align-items: center;
        &.wd100{
          width: 100%;
        }
        label{
          display: inline-block;
          background: #eaecf2;
          width: 80px;
          height: 26px;
          line-height: 26px;
          text-align: right;
          margin-right: 10px;
          border-radius: 3px;
          flex: 0 0 auto;
        }
        span{
          display: flex;
          align-items: center;
          flex: 1 1 auto;
        }
        a{
          color: #409eff;
          &:hover{
            text-decoration: underline;
          }
        }
      }
    }
  }
  .table-li{
     box-shadow: 0 2px 8px 0 rgba(0,0,0,.08);
     border-radius: 15px;
     box-sizing: border-box;
     border: 1px solid #EBEEF5;
     margin-top: 15px;
     min-height: auto!important;
     overflow: hidden;
     li:nth-child(6) label{
      cursor: pointer;
      &:hover{
        color: #eb3333;
      }
     }
  }
  .almanac-table{
    border: 1px solid #ddd;
    width: 100%;
    border-spacing: 0;
    border-collapse: collapse;
    border-radius: 15px;
    table-layout:fixed
  }
  .trips5{
    height: 43px;
    line-height: 43px;
    text-align: center;
    background: #f00;
    color: #fff;
    font-size: 18px;
    margin-top: 13px;
    cursor: pointer;
    border-radius: 5px;
  }
  .namedata{
    margin-top: 13px;
    border: 1px solid #ddd;
    border-radius: 15px;
    overflow: hidden;
    dl{
      display: flex;
      font-size: 14px;
      border-bottom: 1px solid #ddd;
      &.dl-first{
        border-top: 1px solid #ddd;
      }
      dt{
        width: 120px;
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 2px 12px;
        width: 100px;
        line-height: 30px;
        border-right: 1px solid #ddd;
        border-top: none;
        border-bottom:none;
      }
      dd{
        width: calc(100% - 100px);
        padding: 2px 12px;
        line-height: 30px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        span{
          &.green{
            color: green;
          }
          &.red{
            color: red;
            margin-left: 15px;
          }
        }
      }
      &:nth-child(2n){
        background: #f6f8f6;
      }
      dd.wx{
        width: 240px;
        display: flex;
        justify-content: center;
        align-items: center;
        border-right: 1px solid #ddd;
      }
      &:last-child{
        border-bottom: none;
      }
    }
  }
}
.button2{
  position: absolute; 
  right:20px; 
  top:20px;
  color:#409eff;
  cursor: pointer;
  &:hover{
    text-decoration: underline;
  }
}
</style>
<style>
.el-calendar__header{
  display: none!important;
}
.c-body .el-calendar__body{
  padding: 0!important;
}
.c-body .el-calendar-table .el-calendar-day{
  height: 65px;
  font-size: 22px;
  text-align: center;
  box-sizing: border-box;
  overflow: hidden;
}
.c-body .el-calendar-table td.is-selected{
  background: #409eff!important;
  color: #fff;
  border-radius: 5px;
}
.calendar .container .c-body td.is-selected .div-Calendar span.mo,
.calendar .container .c-body td.is-selected .div-Calendar span.red,
.calendar .container .c-body td.is-selected .div-Calendar span.canlendar-jq{
  color: #fff;
}
.c-body .el-calendar-table td.is-selected .el-calendar-day:hover{
  background: #409eff;
  border-radius: 5px;
}
.c-body .el-backtop, .el-calendar-table td.is-today{
  color: #409eff;
  font-weight: 600;
}
.c-body .el-calendar-table .el-calendar-day{
  padding: 0;
}
.c-body .el-calendar-table:not(.is-range) td.next, .el-calendar-table:not(.is-range) td.prev .canlendar-g,
.c-body .el-calendar-table:not(.is-range) td.next, .el-calendar-table:not(.is-range) td.prev .canlendar-n,
.c-body .el-calendar-table:not(.is-range) td.next, .el-calendar-table:not(.is-range) td.prev .canlendar-jq{
 opacity: .6;
}
.info-btn .el-radio-button--small .el-radio-button__inner{
    height: 40px;
    line-height: 40px;
    box-sizing: border-box;
    padding: 0;
    width: 100px;
}
.info-btn .el-radio-button:first-child .el-radio-button__inner{
  color: #409eff;
  background: #ecf5ff;
  border-color: #b3d8ff;
}
.info-btn .el-radio-button:nth-child(2) .el-radio-button__inner{
  color: #67c23a;
  background: #f0f9eb;
  border-color: #c2e7b0;
}
.info-btn .el-radio-button:nth-child(3) .el-radio-button__inner{
  color: #e6a23c;
  background: #fdf6ec;
  border-color: #f5dab1;
}
.info-btn .el-radio-button:nth-child(4) .el-radio-button__inner{
  color: #f56c6c;
  background: #fef0f0;
  border-color: #fbc4c4;
}
.info-btn .el-radio-button:first-child .el-radio-button__orig-radio:checked+.el-radio-button__inner{
  color: #fff;
  background-color: #409eff;
  border-color: #409eff;
}
.info-btn .el-radio-button:first-child .el-radio-button__orig-radio:checked+.el-radio-button__inner::after{
  content: '';
  display: block;
  width: 0;
  height: 0;
  border: 8px solid transparent;
  border-top: 10px solid #409eff;
  margin: 0 auto;
  position: relative;
  top: -2px;
  z-index: 2;
}
.info-btn .el-radio-button:nth-child(2) .el-radio-button__orig-radio:checked+.el-radio-button__inner{
  color: #fff;
  background-color: #67c23a;
  border-color: #67c23a;
}
.info-btn .el-radio-button:nth-child(2) .el-radio-button__orig-radio:checked+.el-radio-button__inner::after{
  content: '';
  display: block;
  width: 0;
  height: 0;
  border: 8px solid transparent;
  border-top: 10px solid #67c23a;
  margin: 0 auto;
  position: relative;
  top: -2px;
  z-index: 2;
}
.info-btn .el-radio-button:nth-child(3) .el-radio-button__orig-radio:checked+.el-radio-button__inner{
  color: #fff;
  background-color: #e6a23c;
  border-color: #e6a23c;
}
.info-btn .el-radio-button:nth-child(3) .el-radio-button__orig-radio:checked+.el-radio-button__inner::after{
  content: '';
  display: block;
  width: 0;
  height: 0;
  border: 8px solid transparent;
  border-top: 10px solid #e6a23c;
  margin: 0 auto;
  position: relative;
  top: -2px;
  z-index: 2;
}
.info-btn .el-radio-button:nth-child(4) .el-radio-button__orig-radio:checked+.el-radio-button__inner{
  color: #fff;
  background-color: #f56c6c;
  border-color: #f56c6c;
}
.info-btn .el-radio-button:nth-child(4) .el-radio-button__orig-radio:checked+.el-radio-button__inner::after{
  content: '';
  display: block;
  width: 0;
  height: 0;
  border: 8px solid transparent;
  border-top: 10px solid #f56c6c;
  margin: 0 auto;
  position: relative;
  top: -2px;
  z-index: 2;
}
.almanac-table table{
  width: 100%;
  border-spacing: 0;
  border-collapse: collapse;
  margin-top: 2px;
}
.almanac-table table td{
  padding: 4px;
  height: 27px;
  border-bottom: 1px solid #ddd;
  border-left: 1px solid #ddd;
  text-align: center;
  line-height: 18px;
}
.almanac-table table td:nth-child(1){
  padding: 4px 2px;
  white-space: nowrap;
}
.almanac-table table tr td:nth-child(1){
  border-left: none;
}
.almanac-table table tr:last-child td{
  border-bottom: none;
}
.info-btn .el-input--small .el-input__inner{
  height: 40px;
  line-height: 40px;
  margin-left: 8px;
  font-size: 14px;
}
.info-btn .el-input--small .el-input__prefix{
  left: 12px;
}
.info-btn .el-input--small .el-input__icon{
  display: none;
}
.info-btn .language .el-input--small .el-input__icon{
  display: block;
}
.info-btn .el-input--small .el-input__icon.el-icon-time{
  display: inline-block;
  font-size: 20px;
  position: relative;
  top: 2px;
}
.astro-table table {
  background: #e6d5e7;
  width: 100%;
  padding: 10px;
  font-size: 18px;
  color: #333;
  margin-top: 10px;
}
.astro-table table tbody {
  background-color: #fff;
  border-radius: 5px;
  display: flex;
  flex-wrap: wrap;
  overflow: hidden;
}
.astro-table table tbody tr {
  width: 25%;
  text-align: center;
  border-right: 1px solid #ebebeb;
  border-bottom: 1px solid #ebebeb;
  box-sizing: border-box;
  padding: 12px 0;
}
.astro-table table tbody tr:nth-child(4n) {
  border-right: none;
}
.astro-table table tbody tr:last-child{
  width: 75%;
}
.astro-table table tbody tr td {
  display: block;
}
.astro-table table tbody tr td:nth-child(1) {
  color: #999;
  height: 24px;
  line-height: 24px;
  font-size: 16px;
}
.astro-table table tbody tr td:nth-child(2) {
  height: 24px;
  line-height: 24px;
  font-size: 18px;
}
.astro ul {
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  margin: 10px 0;
  padding: 0;
}
.astro ul li{
  width: 24%;
  margin: 0 1%;
}
.astro ul li:nth-child(1){
  margin-left: 0;
}
.astro ul li span{
  display: block;
  text-align: center;
  background: #f1f7f5;
  width: 100%;
  height: 42px;
  line-height: 42px;
  margin: 10px 8px 0;
  border-radius: 5px;
  font-size: 18px;
  color: #409eff;
  cursor: pointer;
}
.astro ul li.on span{
  background: #409eff ;
  color: #fff ;
}
.astro ul li.on::after{
  content: '';
  display: block;
  width: 0;
  height: 0;
  border: 8px solid transparent;
  border-top: 10px solid #409eff;
  margin: 0 auto;
  position: relative;
  top: -2px;
  left: 8%;
  z-index: 2;
}
.astro ul li:nth-child(2) span {
  background: #fef7ed;
  color: #5fb698;
}
.astro ul li.on:nth-child(2) span {
  background: #5fb698;
  color: #fff;
}
.astro ul li.on:nth-child(2)::after{
  border-top: 10px solid #5fb698;
}
.astro ul li:nth-child(3) span {
  background: #fef7ed;
  color: #ffac1b;
}
.astro ul li.on:nth-child(3) span {
  background: #ffac1b;
  color: #fff;
}
.astro ul li.on:nth-child(3)::after{
  border-top: 10px solid #ffac1b;
}
.astro ul li:nth-child(4) span {
  background: #fff6fc;
  color: #ff4d8c;
}
.astro ul li.on:nth-child(4) span {
  background: #ff4d8c;
  color: #fff;
}
.astro ul li.on:nth-child(4)::after{
  border-top: 10px solid #ff4d8c;
}
.astro ul li:nth-child(5) span {
  background: #fff6f8;
  color: #5487f6;
}
.astro ul li.on:nth-child(5) span {
  background: #5487f6;
  color: #fff;
}
.astro ul li.on:nth-child(5)::after{
  border-top: 10px solid #5487f6;
}
.astro ul li:nth-child(6) span {
  background: #f6f9ff;
  color: #f2408f;
}
.astro ul li.on:nth-child(6) span {
  background: #f2408f;
  color: #fff;
}
.astro ul li.on:nth-child(6)::after{
  border-top: 10px solid #f2408f;
}
.astro-body{
  padding: 0 0 0 5px;
}
.drawer-detail .el-drawer__body div.astro-body h3:nth-child(1){
    margin-top: 20px !important;
}
.body{
  transform: scale(0.7);
  background:url(../assets/bg.png);
  width: 662px;  
  height: 662px; 
  margin-top: -50px!important;
}
.circle-container {  
  position: absolute;
  width: 250px;
  height: 250px;
  margin: 50px;
  left: 100px;
  top: 100px;
}
.circle {  
  position: absolute;
  top: 50%;
  left: 50%;
  width: 250px;
  height: 250px;
  margin-top: -28px !important;
  margin-left: -25px !important;
  border-radius: 50%;
  transform: rotate(60deg);
}
.circle-container .trips{
  position: absolute;
  left: 45%;
  right: 0;
  top: 50%;
  margin-top: 500px;
  font-size: 18px;
  text-align: center;
  width: 100%;
  color: #999;
}
.sector {  
  position: absolute;
  top: 0;
  left: 50%;
  width: 100%;
  height: 100%;
  overflow: hidden;
  text-align: center;
  line-height: 100px;
  transform-origin: 100% 50%;
  margin: 0px -240px;
}
.sector span {  
  font-size: 35px;
  font-weight: 500;
  display: inline-block;
  transform: rotate(-60deg);
  transform-origin: center center;
}
.sector1 span, .sector12 span{
  position: relative;
  font-size: 24px;
}
.sector1 span{
    position: absolute;
    margin-left: -5px;
    margin-top: -18px;
    transform: rotate(-50deg);
}
.sector12 span{
    margin-left: -25px;
    margin-top: 17px;
}
.sector12 span::after{
  position: absolute;
  left: 30px;
  top: 17px;
  content: '';
  display: block;
  width: 1px;
  height: 70px;
  background: #d69c5c;
}
.sector span.red{
  color: #d84e41;
}
.sector span.blue{
  color: #00bd00;
}
.sector:nth-child(1) { transform: rotate(0deg); }  
.sector:nth-child(2) { transform: rotate(30deg); }  
.sector:nth-child(3) { transform: rotate(60deg); }  
.sector:nth-child(4) { transform: rotate(90deg); }  
.sector:nth-child(5) { transform: rotate(120deg); }  
.sector:nth-child(6) { transform: rotate(150deg); }  
.sector:nth-child(7) { transform: rotate(180deg); }  
.sector:nth-child(8) { transform: rotate(210deg); }  
.sector:nth-child(9) { transform: rotate(240deg); }  
.sector:nth-child(10) { transform: rotate(270deg); }  
.sector:nth-child(11) { transform: rotate(300deg); }  
.sector:nth-child(12) { transform: rotate(330deg); }  
@media screen and (max-width: 1000px) {
  .calendar{
    display: block!important;
  }
  .calendar .container, .calendar .info, .calendar .info ul li{
    width: 100%!important;
  }
  .calendar .festival-baike p{
    display: none;
  }
  .calendar .container .c-header ol li{
    width: 108px!important;
  }
  .calendar .container .c-header ol li:nth-child(2){
    width: 130px!important;
  }
  .calendar .festival-baike2, .calendar .info .info-btn{
    display: block!important;
  }
  .calendar .info, .info-btn .el-input--small .el-input__inner{
    margin-left: 0!important;
    margin-top: 15px!important;
  }
  .calendar .info ul{
    padding-top: 10px;
  }
  .almanac-table{
    overflow: auto;
  }
  .info-btn .el-input--small .el-input__prefix {
    left: 4px!important;
    top: 3px;
  }
  .calendar .info .language{
    position: inherit !important;
    width: 95px!important;
    right: 0!important;
    float: right;
  }
  .calendar .info .language, .info-btn .language .el-input--small .el-input__inner{
    margin-top: 0!important;
  }
  .drawer-detail .el-drawer{
    width: 88%!important;
  }
  .body{
    transform: scale(0.55);
    margin: -130px !important;
  }
}
</style>


// WEBPACK FOOTER //
// src/views/Index.vue